import { mergeStyleSets } from '@uifabric/merge-styles';
import { AzureColors } from '../app/app.classNames';

const cookiesBannerClassNames = (): { [key: string]: string } => mergeStyleSets({
  root: {
    position: 'fixed',
    bottom: 16,
    width: '100%',
    zIndex: 10000
  },
  cookiesBanner: {
    display: 'flex',
    flexWrap: 'wrap',
    background: '#3C3C41',
    marginLeft: 18,
    marginRight: 18,
    color: 'white',
    padding: '24px 44px',
    selectors: {
      button: {
        marginLeft: 'auto',
        marginTop: 12
      }
    }
  },
  textSection: {
    display: 'inline-block',
    selectors: {
      p: {
        marginTop: 0,
        marginBottom: 0,
        lineHeight: 26,
        fontSize: 16
      },
      a: {
        color: AzureColors.lightBlue
      }
    }
  }
});

export default cookiesBannerClassNames;
